<template>
  <div>
    <alarm-popup-wrapper></alarm-popup-wrapper>
    <div class="header-nav">
      <div class="wrap">
        <ul class="nav">
          <li v-if="!loginState"><a href="#" @click.prevent="goLogin">로그인</a></li>
          <li v-else @focusin="focus('userInfoList')" @mouseenter="focus('userInfoList')" @mouseleave="blur('userInfoList')" class="over-parent-1depth">
            <button type="button" class="arrow" data-util-menu="true">{{name}}</button>
            <div ref="userInfoList" class="header-over-1depth">
              <div class="profile-image-area">
                <img v-if="profileImage" :src="getImage(profileImage)" :alt="profileImageAlt"/>
              </div>
              <span class="name">{{name}}</span>

              <router-link v-if="profilecount > 1" to="/member/profile_change.html" class="change" data-util-menu="true">사용자 변경</router-link>
              <a v-else href="#" @click.prevent="profileEditUrl"  class="change" data-util-menu="true">프로필 편집</a>

              <a v-if="profilecount === 1" href="#" @click.prevent="profileEditUrl" class="a11y-hidden" data-util-menu="true">프로필 이미지 변경</a>

              <ul class="profile-menu-list">
                <li>
                  <a href="https://member.wavve.com/me" data-util-menu="true">회원정보 수정</a>
                </li>
                <li>
                  <a href="#" @click.prevent="goToadultContentsSetting()" data-util-menu="true">성인 콘텐츠 설정</a>
                </li>
                <li>
                  <button type="button" @click.prevent="showAlarm()" data-util-menu="true">알림함<span class="alarm-count">{{ alarmCount }}</span>
                  </button>
                </li>
                <li>
                  <button type="button" @click.prevent="isLogout()" data-util-menu="true">로그아웃</button>
                </li>
              </ul>
            </div>
          </li>
          <li><router-link to="/voucher/index.html">이용권</router-link></li>
          <li @focusin="focus('registList')" @mouseenter="focus('registList')" @mouseleave="blur('registList')" class="over-parent-1depth ticket-util-menu">
            <button type="button" data-regist-menu="true" class="arrow">쿠폰&middot;코인</button>
            <div ref="registList" class="header-over-1depth">
              <ul class="profile-menu-list">
                <li>
                  <a href="#" @click.prevent="goUrl({path: '/my/coupon', name: 'coupon'})" data-regist-menu="true">쿠폰 등록</a>
                </li>
                <li>
                  <a href="#" @click.prevent="goUrl({path: '/my/coin', name: 'coin'})" data-regist-menu="true">코인 충전</a>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <a href="#" @click.prevent="goUrl({path: '/voucher/wavveon', name: 'voucher_pooqzone'})">웨이브온</a>
          </li>
          <li>
            <a href="#" @click.prevent="goUrl({path: '/customer/event_list.html', name: 'event_list'})">이벤트</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getAlarmsNew } from '@/common/utils/request'
import { logoutProc } from '@/common/utils/login'
import cookie from '@/common/utils/cookie'
import { url } from '@/common/filters/url.filter'
import { mapGetters, mapMutations } from 'vuex'
import {
  ALARM_POPUP_TYPE_ALL, FLUSH_EVENT, SHOW_ALARM_POPUP, UPDATE_EVENT_LAYOUT_CONTENT, UPDATE_MAIN_LAYOUT_CONTENT
} from '@/common/resources/const'
import constant from '@/common/resources/constant'
import AlarmPopupWrapper from '@/components/common/header/AlarmPopupWrapper'
import { PATH_NAME_ADULT_CONTENTS } from '@/common/resources/router.const'
import { resizeThumbnail } from '@/common/utils/image'
export default {
  components: {
    AlarmPopupWrapper
  },
  filters: {
    url
  },
  data () {
    return {
      // showLoginPop: false,
      loginState: false, // 로그인 여부
      name: '회원님',
      profilecount: 0,
      profileImage: 'img.wavve.com/service30/profile/0.png',
      profileImageAlt: '',
      // isShowAlarm: false,
      alarmCount: 0,
      referer: '',
      isMenuOpen: false
    }
  },
  computed: {
    ...mapGetters(['menuState', 'csInfo'])
  },
  methods: {
    ...mapMutations(['showLoginPopup', 'hideLoginPopup']),
    getImage (img) {
      return resizeThumbnail(img, { width: 0, height: 0, option: 20, quality: 80 })
    },
    goLogin () {
      if (this.$route.name !== 'login') {
        this.$router.replace(`/member/login?referer=${encodeURIComponent(this.$route.fullPath)}`)
      }
    },
    goUrl (pathInfo) {
      const { path, name } = pathInfo
      if (name === this.$route.name) {
        this.$events.$emit(UPDATE_MAIN_LAYOUT_CONTENT)
        this.$events.$emit(UPDATE_EVENT_LAYOUT_CONTENT)
      } else {
        this.$router.push(path)
      }
    },
    isLogout () {
      this.$events.$emit(FLUSH_EVENT)
      logoutProc().then(() => {
        window.location.href = '/index.html'
      }).catch(() => {
        alert(constant.MSG_COMMON_ERROR)
      })
    },
    showAlarm () {
      this.$events.$emit(SHOW_ALARM_POPUP, ALARM_POPUP_TYPE_ALL)
    },
    initialize () {
      this.loginState = cookie.isCsInfo()
      this.profilecount = Number(cookie.userInfo('profilecount'))
      this.name = cookie.userInfo('profilename') || '회원님'
      this.profileImage = cookie.userInfo('profileimage') || 'img.wavve.com/service30/profile/0.png'
      this.profileImageAlt = cookie.userInfo('alt') || ''
    },
    goToadultContentsSetting () {
      this.$router.push({ name: PATH_NAME_ADULT_CONTENTS })
    },
    profileEditUrl () {
      if (location.href.indexOf('member/profile_edit.html') > -1) return '/member/profile_edit.html?profileId=0'
      this.$router.push('/member/profile_edit.html?profileId=0&referer=' + encodeURIComponent(location.href))
    },
    focus (type) {
      this.$refs[type].classList.add('on')
    },
    blur (type) {
      this.$refs[type].classList.remove('on')
    },
    keyup (e) {
      if (e.target.dataset.registMenu !== 'true' || e.keyCode === 13) this.blur('registList')
      if (this.loginState && (e.target.dataset.utilMenu !== 'true' || e.keyCode === 13)) this.blur('userInfoList')
    }
  },
  mounted () {
    document.addEventListener('keyup', this.keyup)
  },
  created () {
    this.initialize()
    getAlarmsNew().then((response) => {
      this.alarmCount = +response.data.count
      if (this.alarmCount > 99) {
        this.alarmCount = '99+'
      }
    })
  },
  watch: {
    menuState () {
      this.initialize()
    },
    csInfo () {
      this.initialize()
    }
  },
  beforeDestroy () {
    document.removeEventListener('keyup', this.keyup)
  }
}
</script>
